import { getSpiderTagsAndRows } from './util';
import D_Number from '@utils/number';
import { defaultToolTip } from '@components/charts/config';
import { wrap } from './waterfallchart';

const formatSpiderData = (data = [], buyerName, targetName) => {
  const { tagA, tagB, dataRows } = getSpiderTagsAndRows(
    data,
    buyerName,
    targetName,
  );

  const categorySectors = dataRows.length;

  const yAxis = dataRows.reduce(
    (acc, e, i) => [
      ...acc,
      {
        gridLineInterpolation: 'polygon',
        lineWidth: 0,
        min: 0,
        max: Math.max(e.a, e.b),
        angle: (i * 360) / categorySectors,
        gridLineColor: '#666666',
        tickAmount: 4,
        labels: {
          enabled: false, // 隐藏 y 轴的坐标标签
        },
      },
    ],
    [
      {
        gridLineInterpolation: 'polygon',
        lineWidth: 0,
        min: 0,
        tickAmount: 4,
        max: 1,
        visible: false,
        labels: {
          enabled: false, // 隐藏 y 轴的坐标标签
        },
      },
    ],
  );

  return {
    yAxis,
    categories: Array.isArray(dataRows) ? dataRows.map((e) => e.c) : [],
    series: Array.isArray(dataRows)
      ? [
          {
            name: tagA,
            data: dataRows.map((e, i) => ({
              val: e.aLabel || e.a,
              y: e.a / yAxis[i + 1].max,
              comment: e.d,
            })),
            pointPlacement: 'on',
            color: 'rgb(255, 182, 0, 0.7)', //'#FFB600',
            yAxis: 0,
          },
          {
            name: tagB,
            data: dataRows.map((e, i) => ({
              val: e.bLabel || e.b,
              y: e.b / yAxis[i + 1].max,
              comment: e.d,
            })),
            pointPlacement: 'on',
            color: 'rgb(0, 129, 233, 0.7)', //'#0081E9',
            yAxis: 0,
          },
        ]
      : [],
  };
};

export const buildSpiderChartOption = (
  inputData,
  buyerName,
  targetName,
  isLightMode,
) => {
  // 从新设置color的值，他这块非常奇怪，明明没设置color但是dark模式的时候一直有个333颜色【defaultToolTip也没得】
  if (isLightMode) {
    defaultToolTip.style.color = '#333333';
  } else {
    defaultToolTip.style.color = '#DBDBDB';
  }

  const { series, categories, yAxis } = formatSpiderData(
    inputData,
    buyerName,
    targetName,
  );
  const result = {
    chart: {
      polar: true,
      type: 'area',
    },
    credits: {
      enabled: false,
    },
    title: {
      text: undefined,
    },

    yAxis,

    legend: {
      align: 'left',
      verticalAlign: 'top',
      layout: 'horizontal',
    },

    xAxis: {
      categories,
      tickmarkPlacement: 'on',
      lineWidth: 0,
    },
    series,
    tooltip: {
      shared: true,
      ...defaultToolTip,
      formatter() {
        return (
          this.points.reduce(function (s, point) {
            return `${s}<span style="color:${point.color}">\u25CF</span> 
              ${
                point.series.name
              }: <b>${D_Number.addSeparator(point.point.val)}</b>
              <br/>`;
          }, `<span style="font-size: 0.8em">${this.key}</span><br/>`) +
          wrap(this.point.comment || '')
        );
      },
    },
  };

  return result;
};
